import React, { useEffect } from 'react';
import '../styles/Contact.css'; // Keep your custom styles

const Contact = () => {
  useEffect(() => {
    document.title = 'Contact | Bularis Tech';
  }, []);

  return (
    <div className="contact">
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>We’d love to hear from you. Please fill out the form below to get in touch.</p>
      </div>

      <form
        className="contact-form"
        action="https://formsubmit.co/info@bularis.com" // Replace with your actual email
        method="POST"
      >
        {/* To disable captcha and redirect on success */}
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_next" value="https://bularis.com" />

        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
        />
        <textarea
          name="message"
          placeholder="Your Message"
          rows="5"
          required
        ></textarea>
        <button type="submit">Send Message</button>
      </form>
    </div>
  );
};

export default Contact;